/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'
export const IntegrationProvider = {
	Teya: 'teya',
	Nets: 'nets',
	'Verifone-ecom': 'verifone-ecom',
	'Rapyd-cloudlink': 'rapyd-cloudlink',
	'Verifone-pos-cloud': 'verifone-pos-cloud',
	Struct: 'struct'
} as const
export type IntegrationProviderType = (typeof IntegrationProvider)[keyof typeof IntegrationProvider]
export const IntegrationAuth = {
	None: 'none',
	Oauth: 'oauth'
} as const
export type IntegrationAuthType = (typeof IntegrationAuth)[keyof typeof IntegrationAuth]
export type IntegrationSummary = {
	provider: IntegrationProviderType
	auth: IntegrationAuthType
	hasGlobalConfig: boolean
	overrideCount: number
}
export const TeyaIntegrationStatus = {
	NotConnected: 'NOT_CONNECTED',
	Active: 'ACTIVE',
	Error: 'ERROR',
	Revoked: 'REVOKED'
} as const
export type TeyaIntegrationStatusType = (typeof TeyaIntegrationStatus)[keyof typeof TeyaIntegrationStatus]
export type TeyaIntegration = {
	available: boolean
	status: TeyaIntegrationStatusType
	scope?: string
	connectedAt?: string
	lastRefreshedAt?: string
	expiresAt?: string
}
export type TeyaStore = {
	id: string
	name?: string
	address?: string
}
export type TeyaTerminal = {
	terminalId: string
	name?: string
	serialNumber?: string
}
export type RapydDeviceTokenStatus = {
	paired: boolean
	deviceToken?: string
}
export const OverrideScope = {
	Saleschannel: 'salesChannel',
	Pointofsale: 'pointOfSale'
} as const
export type OverrideScopeType = (typeof OverrideScope)[keyof typeof OverrideScope]
export const IntegrationFieldType = {
	Text: 'text',
	Number: 'number',
	Select: 'select',
	Boolean: 'boolean'
} as const
export type IntegrationFieldTypeType = (typeof IntegrationFieldType)[keyof typeof IntegrationFieldType]
export type IntegrationFieldDescriptor = {
	key: string
	type: IntegrationFieldTypeType
	required?: boolean
	options?: string[]
	overridable: boolean
	secret?: boolean
}
export type IntegrationScopedValues = {
	values: any
	secretsSet: string[]
}
export type IntegrationOverride = {
	featureId: number
	scope: OverrideScopeType
	targetUuid: string
	targetName: string
	values: any
	secretsSet: string[]
}
export type IntegrationConfig = {
	provider: IntegrationProviderType
	auth: IntegrationAuthType
	overrideScope: OverrideScopeType
	fields: IntegrationFieldDescriptor[]
	global: IntegrationScopedValues
	overrides: IntegrationOverride[]
}

export const zIntegrationProvider = z.enum([
	'teya',
	'nets',
	'verifone-ecom',
	'rapyd-cloudlink',
	'verifone-pos-cloud',
	'struct'
])
export const zIntegrationAuth = z.enum(['none', 'oauth'])
export const zIntegrationSummary = z.object({
	provider: zIntegrationProvider,
	auth: zIntegrationAuth,
	hasGlobalConfig: z.boolean(),
	overrideCount: z.number()
})
export const zTeyaIntegrationStatus = z.enum(['NOT_CONNECTED', 'ACTIVE', 'ERROR', 'REVOKED'])
export const zTeyaIntegration = z.object({
	available: z.boolean(),
	status: zTeyaIntegrationStatus,
	scope: z.string().optional(),
	connectedAt: z.string().optional(),
	lastRefreshedAt: z.string().optional(),
	expiresAt: z.string().optional()
})
export const zTeyaStore = z.object({
	id: z.string(),
	name: z.string().optional(),
	address: z.string().optional()
})
export const zTeyaTerminal = z.object({
	terminalId: z.string(),
	name: z.string().optional(),
	serialNumber: z.string().optional()
})
export const zRapydDeviceTokenStatus = z.object({
	paired: z.boolean(),
	deviceToken: z.string().optional()
})
export const zOverrideScope = z.enum(['salesChannel', 'pointOfSale'])
export const zIntegrationFieldType = z.enum(['text', 'number', 'select', 'boolean'])
export const zIntegrationFieldDescriptor = z.object({
	key: z.string(),
	type: zIntegrationFieldType,
	required: z.boolean().optional(),
	options: z.array(z.string()).optional(),
	overridable: z.boolean(),
	secret: z.boolean().optional()
})
export const zIntegrationScopedValues = z.object({
	values: z.any(),
	secretsSet: z.array(z.string())
})
export const zIntegrationOverride = z.object({
	featureId: z.number(),
	scope: zOverrideScope,
	targetUuid: z.string(),
	targetName: z.string(),
	values: z.any(),
	secretsSet: z.array(z.string())
})
export const zIntegrationConfig = z.object({
	provider: zIntegrationProvider,
	auth: zIntegrationAuth,
	overrideScope: zOverrideScope,
	fields: z.array(zIntegrationFieldDescriptor),
	global: zIntegrationScopedValues,
	overrides: z.array(zIntegrationOverride)
})
